import { createAction, createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    isLoading: true,
    error: null,
    user: {},
  },
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setUserData: (state, action) => {
      state.isLoading = false;
      state.user = action.payload;
      state.error = null;
    },
    setError: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

// ACTIONS
export const setLoadingAction = createAction("user/setLoading");
export const setUserDataAction = createAction("user/setUserData");
export const setErrorAction = createAction("user/setError");

// REDUCERS
export default userSlice.reducer;
